import { environment } from '../environments/environment';

/**
 * Used to denote an empty value in infrastructure/apo-portal/pipelines/apo-portal-cd.yml.
 */
export const PLACEHOLDER = '<placeholder>';

function createLogRocket(appID: string): typeof import('logrocket') {
  if (appID === '' || appID === PLACEHOLDER) {
    const mock: typeof import('logrocket') = {
      init: function init() {},
      log: function log() {},
      info: function info() {},
      warn: function warn() {},
      error: function error() {},
      debug: function debug() {},
      identify: function identify() {},
      get sessionURL() {
        return '';
      },
      reduxMiddleware: function reduxMiddleware() {
        return function () {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return function (next: any) {
            return function (action: unknown) {
              return next(action);
            };
          };
        };
      },
      track: function track() {},
      getSessionURL: function getSessionURL() {},
      startNewSession: function startNewSession() {},
      captureMessage: function captureMessage() {},
      captureException: function captureException() {},
      version: undefined,
    };
    return mock;
  }

  // eslint-disable-next-line @typescript-eslint/no-require-imports
  return require('logrocket');
}

/**
 * The APO Portal-owned LogRocket client. It is a no-op outside configured environments.
 */
export const LogRocket = createLogRocket(environment.logRocketId);

/**
 * Gets the LogRocket Session URL.
 */
export const useSessionURL = (): Promise<string | null> => {
  return new Promise((resolve) => {
    LogRocket.getSessionURL((sessionURL) => {
      resolve(sessionURL);
    });
  });
};
